import { render, staticRenderFns } from "./SelectedMultipleDinamicField.vue?vue&type=template&id=652e9286"
import script from "./SelectedMultipleDinamicField.vue?vue&type=script&lang=js"
export * from "./SelectedMultipleDinamicField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports